export default __webpack_public_path__ + "static/media/insppvServicesbanking.7611ba9c.svg";